import React from 'react'
import type { BaseRange } from 'slate'

import { noOp } from '@/utils/helpers'

import type { UserMention } from '../../types'

export type MentionsContextType = {
  filter: string
  setFilter: (input: string) => void
  userList: UserMention[]
  setUserList: React.Dispatch<React.SetStateAction<UserMention[]>>
  usersInThread: UserMention[]
  menuIndex: number
  setMenuIndex: React.Dispatch<React.SetStateAction<number>>
  rangeToReplace: BaseRange | null
  setRangeToReplace: React.Dispatch<React.SetStateAction<BaseRange | null>>
  closeMentionsMenu: () => void
  getMentionSuggestions: (userInput: string) => Promise<UserMention[]>
}

export const MentionsContext = React.createContext<MentionsContextType>({
  filter: '',
  setFilter: noOp,
  userList: [],
  setUserList: noOp,
  usersInThread: [],
  menuIndex: -1,
  setMenuIndex: noOp,
  rangeToReplace: null,
  setRangeToReplace: noOp,
  closeMentionsMenu: noOp,
  getMentionSuggestions: async () => Promise.resolve([]),
})

export function useMentionsContext(): MentionsContextType {
  return React.useContext(MentionsContext)
}
